function ownKeys(e, r) {var t = Object.keys(e);if (Object.getOwnPropertySymbols) {var o = Object.getOwnPropertySymbols(e);r && (o = o.filter(function (r) {return Object.getOwnPropertyDescriptor(e, r).enumerable;})), t.push.apply(t, o);}return t;}function _objectSpread(e) {for (var r = 1; r < arguments.length; r++) {var t = null != arguments[r] ? arguments[r] : {};r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {_defineProperty(e, r, t[r]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));});}return e;}function _defineProperty(e, r, t) {return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;}function _toPropertyKey(t) {var i = _toPrimitive(t, "string");return "symbol" == typeof i ? i : i + "";}function _toPrimitive(t, r) {if ("object" != typeof t || !t) return t;var e = t[Symbol.toPrimitive];if (void 0 !== e) {var i = e.call(t, r || "default");if ("object" != typeof i) return i;throw new TypeError("@@toPrimitive must return a primitive value.");}return ("string" === r ? String : Number)(t);}import L from 'leaflet';
import { t } from "../I18N";
import { getGoogleLayer } from "./GoogleMapLayer";

const DEFAULT_MAPBOX_TOKEN =
'pk.eyJ1Ijoibnd5dSIsImEiOiJjazlta3liaWowMHBkM2pwaHFiaG0wcDBqIn0.47wbPKb2A4u3iCt34qrSRw';

const mapBoxStyles = {
  Streets: 'mapbox/streets-v11',
  Satellite: 'mapbox/satellite-v9',
  Hybrid: 'mapbox/satellite-streets-v11',
  Dark: 'mapbox/dark-v11'
};

const GoogleMapStyles = {
  Streets: 'roadmap',
  Satellite: 'satellite',
  Hybrid: 'hybrid'
};

const getGoogleLayers = () =>
Object.keys(GoogleMapStyles).reduce(
  (layers, styleId) => _objectSpread(_objectSpread({},
  layers), {}, {
    [styleId]: { layer: getGoogleLayer(GoogleMapStyles[styleId]), key: styleId } }),

  {}
);

const getMapboxLayers =

(accessToken) => {
  const mapboxUrl =
  'https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}';

  return Object.keys(mapBoxStyles).reduce((layers, styleId) => {
    const styleLabel = t('System', styleId, null, false);
    return _objectSpread(_objectSpread({},
    layers), {}, {
      [styleLabel]: {
        layer: L.tileLayer(mapboxUrl, {
          id: mapBoxStyles[styleId],
          tileSize: 512,
          zoomOffset: -1,
          accessToken: accessToken || DEFAULT_MAPBOX_TOKEN,
          zIndex: 0
        }),
        key: styleId
      } });

  }, {});
};

const mapFunction =

{
  google: getGoogleLayers,
  mapbox: getMapboxLayers
};
const getMapProvider = (provider, mapApiKey) => {
  const mapLayers = mapFunction[provider](mapApiKey);
  return mapLayers;
};

export { getMapProvider };